import { PerspectiveCamera } from '@react-three/drei'

import React, { useRef, useState } from 'react'
import { useFrame, useThree } from '@react-three/fiber'
import * as THREE from 'three'
import { MathUtils } from 'three'

type CameraProps = JSX.IntrinsicElements['perspectiveCamera'] & {}
type HolderProps = JSX.IntrinsicElements['object3D'] & {}

type FOVCameraProps = {
  cameraProps: CameraProps,
  holderProps: HolderProps,
  fov?: number,
  fovStart?: number,
  fovEnd?: number,
  ratioStart?: number,
  ratioEnd?: number,
  makeDefault?: boolean
  manual?: boolean // TODO: Tell TJ what this does ?????
  children?: React.ReactNode
}

const searchParams = new URLSearchParams(window.location.search)
function tryGetURLParamterAsNumber (_name:string, _defaultValue:number) : number {
  const value = searchParams.get(_name)
  if (value == null || value === 'false' || value === 'true') {
    return _defaultValue
  }
  return parseFloat(value)
}

const GlobalFovRatioStart = tryGetURLParamterAsNumber('FovRatioStart', 100)
const GlobalFovRatioEnd = tryGetURLParamterAsNumber('FovRatioEnd', 50)
const GlobalFovStart = tryGetURLParamterAsNumber('FovStart', 0.3)
const GlobalFovEnd = tryGetURLParamterAsNumber('FovEnd', 1.9)

// eslint-disable-next-line no-extra-parens
const FOVCamera = React.forwardRef<THREE.Camera, FOVCameraProps>((props, cameraRef) => {
  const containerNodeRef = useRef<THREE.Object3D>()
  const [fovStart] = useState(props.fovStart ?? GlobalFovRatioStart)
  const [fovEnd] = useState(props.fovEnd ?? GlobalFovRatioEnd)
  const [ratioStart] = useState(props.ratioStart ?? GlobalFovStart)
  const [ratioEnd] = useState(props.ratioEnd ?? GlobalFovEnd)
  const [fov, setFov] = useState(props.fov ?? 100)
  const { gl } = useThree()

  useFrame((_state, _deltaTime) => {
    const currentRatio = gl.domElement.clientWidth / gl.domElement.clientHeight
    const currentPosition = (currentRatio - ratioStart) / (ratioEnd - ratioStart)
    setFov(MathUtils.lerp(fovStart, fovEnd, currentPosition))
  })

  return (
    <object3D {...props.holderProps} name={'root parent'}>
      <object3D name="container parent" ref={containerNodeRef}>
        <PerspectiveCamera ref={cameraRef}
                           {...props.cameraProps}
                           fov={fov}
                           name={'the camera'} />
      </object3D>
    </object3D>
  )
})
FOVCamera.displayName = 'FOVCamera'
export default FOVCamera
